export class Role {
    public id: number;
    public name: string;
    public display_name: string;
    public description: string;
}
